// extracted by mini-css-extract-plugin
export default {"readyToConnect":"ready-to-connect__LmUq0t1b","content":"content___SPs0Lxm","footer":"footer__pmQCqYW_"};